import React, { useState } from "react";

import { useMediaQuery } from "react-responsive";
import InspectionTable from "./tables/InspectionTable";

function InspectionPage() {
  const istablet = useMediaQuery({ query: "(max-width: 640px)" });
  const [searchList, setSearchList] = useState("");

  return (
    <div className="mt-1">
      <h3>Inspection</h3>
      <div
        className={`flex ${
          istablet ? "justify-center gap-1" : "justify-end"
        } flex-wrap`}
        style={{ alignItems: "end" }}
      >
        <div
          className="input-field-style "
          style={{ height: "40px", width: "300px", marginTop: "8px" }}
        >
          <span className="material-symbols-outlined primary ">search</span>
          <input
            className="browser-default input-field  "
            placeholder="Search"
            value={searchList}
            type="text"
            onChange={(e) => setSearchList(e.target.value)}
          />
        </div>
      </div>
      <InspectionTable searchList={searchList} />
    </div>
  );
}

export default InspectionPage;
